import _ from 'underscore';
import Promise from 'bluebird';
import { Decorator } from './decorator';

export class GridDataParametersDecorator extends Decorator {
  /**
   * Creates an instance of GridDataParametersDecorator.
   * @param {Object} {
   *  entitySet - The entitySet to query. For grid, usually entity['Default.GridData],
   *  isOdataActionSource - True if using OData Actions to make the call (POST call) instead of GET
   *  isCustomerHierachyRequest - True if it is a Customer Hierarchy request
   *  loadDirectlyLinkedAccounts - In case of a Customer Hierarchy request,
   *    True if only the directly linked accounts need to be queried
   *  accountModes - string array ['Expert'] for filtering on Expert mode accounts,
   *    ['Smart'] for UP Smart accounts, ['Expert','Smart'] for both
   * }
   * @memberof GridDataParametersDecorator
   */
  constructor({
    entitySet,
    isOdataActionSource,
    preloadOptions,
    isCustomerHierachyRequest = false,
    loadDirectlyLinkedAccounts = null,
    accountModes = null,
    associationType = null,
    adExtensionTypes = null,
  }) {
    super({ name: 'gridDataParameters' });

    this.entitySet = entitySet;
    this.isOdataActionSource = isOdataActionSource;
    this.isCustomerHierachyRequest = isCustomerHierachyRequest;
    this.preloadOptions = preloadOptions;
    this.loadDirectlyLinkedAccounts = loadDirectlyLinkedAccounts;
    this.accountModes = accountModes;
    this.associationType = associationType;
    this.adExtensionTypes = adExtensionTypes;
  }

  getValueAsync() {
    return this.loadDirectlyLinkedAccounts ?
      this.loadDirectlyLinkedAccounts() :
      Promise.resolve({ loadDirectlyLinkedAccounts: false });
  }

  buildQuery(queryParams, { loadDirectlyLinkedAccounts }) {
    if (!this.isOdataActionSource) {
      return queryParams;
    }
    const transformedQueryParams = _.extend({}, queryParams);
    const params = {
      ...(transformedQueryParams.bodyParameters || {}),
      gridDataParameters: queryParams.gridDataParameters,
    };

    if (this.isCustomerHierachyRequest) {
      params.isCustomerHierachyRequest = true;
      params.loadDirectlyLinkedAccounts = loadDirectlyLinkedAccounts;
    }

    if (this.preloadOptions) {
      params.preloadOptions = this.preloadOptions;
    }

    if (this.associationType) {
      params.associationType = this.associationType;
    }

    if (this.adExtensionTypes) {
      params.adExtensionTypes = this.adExtensionTypes;
    }

    if (this.accountModes) {
      params.accountModes = this.accountModes;
    }

    transformedQueryParams.options = _.extend({}, queryParams.options || {}, {
      entitySet: this.entitySet
        .$call(params),
    });

    delete transformedQueryParams.gridDataParameters;
    transformedQueryParams.bodyParameters = params;
    return transformedQueryParams;
  }
}
